import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/frontend/utils';
type CSharpLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const CSharpLogo: React.FC<CSharpLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "C# logo";
    t9 = cn("stroke-[#A855F7]", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16476)"><path d="M13.3333 12C13.3333 10.9391 12.9119 9.92172 12.1618 9.17157C11.4116 8.42143 10.3942 8 9.33333 8H8.66667C7.42899 8 6.24201 8.49167 5.36684 9.36684C4.49167 10.242 4 11.429 4 12.6667V19.3333C4 20.571 4.49167 21.758 5.36684 22.6332C6.24201 23.5083 7.42899 24 8.66667 24H9.33333C10.3942 24 11.4116 23.5786 12.1618 22.8284C12.9119 22.0783 13.3333 21.0609 13.3333 20" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M21.3333 9.33301L20 22.6663" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M26.6663 9.33301L25.333 22.6663" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M18.667 13.333H28.667" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M28 18.667H18" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16476"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};